export function uint8ArrayToBase64(uint8arr) {
    let binary = "";
    const chunkSize = 0x8000; // 32 KB за раз
    for (let i = 0; i < uint8arr.length; i += chunkSize) {
        const chunk = uint8arr.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, chunk);
    }
    return btoa(binary);
}
